// extracted by mini-css-extract-plugin
export default {"subTab1BasicInfo":"SubTab1_subTab1BasicInfo__3iZbR","basicInfoForm":"SubTab1_basicInfoForm__mdTj8"};